import { useIntl } from 'react-intl';

import { IRestaurant } from '@rbi-ctg/store';
import { useLocale } from 'state/intl';
import { readableDistanceFromStore } from 'utils/restaurant';

import { useDistance } from './use-distance';

interface UserDistanceTextOptions {
  restaurant: IRestaurant;
  shouldUseUserCoordinatesIfAvailable?: boolean;
}

export const useDistanceText = ({
  restaurant,
  shouldUseUserCoordinatesIfAvailable = false,
}: UserDistanceTextOptions) => {
  const { formatMessage } = useIntl();
  const { region } = useLocale();

  const distance = useDistance({ restaurant, shouldUseUserCoordinatesIfAvailable });

  return distance ? readableDistanceFromStore(distance, region, formatMessage) : '';
};
